export default "/assets/images/shushing-face.6ad4e8f7c031580d.png";